import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export default forwardRef<SVGSVGElement, SvgIconProps>(function AppLogoIcon(
  props: SvgIconProps,
  ref,
) {
  return (
    <SvgIcon
      ref={ref}
      {...props}
      width='127'
      height='20'
      viewBox='0 0 127 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.0933 11.4961H19.0952V15.1895C19.0952 15.1958 19.0925 17.2957 17.6802 18.6367C16.2724 19.9733 14.6312 19.9911 14.6157 19.9912C14.6157 19.9912 11.6686 20.1885 10.1362 18.7598C9.19913 18.0256 8.26207 16.0277 8.25049 16.0029C8.2757 16.0296 11.6722 19.6167 12.6118 18.3906C13.5504 17.1653 13.2039 12.7687 13.2007 12.7275V12.6787H13.1997V4.84863C13.1997 4.84863 13.1997 2.74442 14.6138 1.40137C16.0282 0.0583344 17.6792 0.046875 17.6792 0.046875H19.0933V11.4961Z'
        fill='url(#paint0_linear_20124_52262)'
      />
      <path
        d='M5.89355 11.3945V16.9883C5.89317 16.9881 5.89171 16.9881 5.88965 16.9873C5.82824 18.6303 4.53537 19.9431 2.94727 19.9434C1.35894 19.9434 0.0643208 18.6305 0.00292969 16.9873C0.00110038 16.9875 0.000155972 16.9883 0 16.9883V3.49512L0.118164 2.9541L0.47168 2.75586L1.29688 2.26367L5.89355 11.3945Z'
        fill='url(#paint1_linear_20124_52262)'
      />
      <path
        d='M0.942981 2.75707C0.117873 2.63395 0 3.61885 0 3.61885C0 3.61885 0 2.14151 0.707236 1.15662C1.41447 0.171726 2.5932 0.0486149 2.5932 0.0486149C2.5932 0.0486149 4.47916 -0.197542 5.89363 0.417949C7.3081 1.03344 8.13321 2.88018 8.13321 2.88018L13.2017 12.7291C13.2017 12.7291 13.6732 18.0974 12.3766 18.7129C10.2549 19.5747 8.13321 15.8069 8.13321 15.8069L2.00383 3.86507C2.00383 3.86507 1.65022 3.00329 0.942981 2.75707Z'
        fill='url(#paint2_linear_20124_52262)'
      />
      <path
        opacity='0.7'
        d='M5.45515 4.91143L2.72221 5.27761L5.04263 9.76027L7.75767 9.44803C8.38215 9.37621 8.93579 9.01475 9.25236 8.47218L10.2 6.848L7.87972 2.36409L6.89041 3.97759C6.57692 4.48889 6.04999 4.83172 5.45515 4.91143Z'
        fill='url(#paint3_linear_20124_52262)'
      />
      <path
        opacity='0.7'
        d='M8.27862 10.3317L5.54014 10.7106L7.86035 15.1772L10.5754 14.865C11.1999 14.7932 11.7535 14.4317 12.0701 13.8892L13.0177 12.265L10.6974 7.78106L9.7054 9.39903C9.39346 9.90777 8.87014 10.2499 8.27862 10.3317Z'
        fill='url(#paint4_linear_20124_52262)'
      />
      <path
        d='M19.0957 13.4658H19.0947V15.1895C19.0947 15.196 19.0928 17.21 17.916 18.3906C16.7375 19.5729 16.2656 19.5732 16.2656 19.5732C16.244 19.5871 15.4851 20.0647 13.9082 19.9912C12.7446 19.9912 12.5001 19.8235 12.4941 19.8193C12.5003 19.8197 14.617 19.94 15.3232 18.3906C16.0268 16.8469 15.837 12.7704 15.835 12.7275V11.4961H15.8359V4.84863C15.8359 4.84863 15.8358 2.74441 16.6182 1.40137C17.4006 0.0583344 18.3135 0.046875 18.3135 0.046875H19.0957V13.4658Z'
        fill='url(#paint5_linear_20124_52262)'
        fillOpacity='0.3'
      />
      <path
        d='M5.53809 10.71L5.8916 11.4482V16.127C5.89331 16.1447 5.97338 16.9966 5.77344 17.7275C5.53763 18.589 5.04079 19.149 4.35938 19.5742C4.07898 19.7492 3.65191 19.9433 2.82715 19.9434C1.76629 19.8939 1.17676 19.3271 1.17676 19.3271C1.17676 19.3271 2.59158 19.6484 3.29883 18.0967C4.00257 16.5525 3.81245 12.4739 3.81055 12.4336V7.38574L5.53809 10.71Z'
        fill='url(#paint6_linear_20124_52262)'
        fillOpacity='0.19'
      />
      <path
        d='M14.8521 1.6013C16.0504 0.260988 19.0955 0.0500497 19.0955 0.0500497C18.1968 0.0500403 17.5143 -0.0308958 16.6202 0.24698C15.7951 0.503387 15.0879 0.862631 14.4985 1.47819C13.2019 2.83243 13.2019 4.92531 13.2019 4.92531V12.6813C13.2019 12.6813 13.7913 17.2364 12.4947 18.5907C11.1981 19.9449 8.36914 16.2516 8.36914 16.2516C8.36914 16.2516 9.20078 17.892 10.1372 18.5907C10.9623 19.2062 12.1411 19.5756 12.8483 18.96C13.5555 18.3444 13.6734 16.9902 13.7913 15.3898C13.9092 13.7893 13.6027 5.54089 13.6734 4.8022C13.7441 4.06351 13.9652 2.59337 14.8521 1.6013Z'
        fill='url(#paint7_linear_20124_52262)'
      />
      <path
        d='M124.905 16.8657C123.217 16.8657 122.163 16.0986 122.163 14.2575V7.85208H120.763V7.10414C121.127 6.98907 121.702 6.89318 122.163 6.85482V4.53428L123.237 4.38086V6.83564H126.746V7.85208H123.237V14.0849C123.237 15.3315 123.889 15.8301 125.039 15.8301C125.576 15.8301 126.516 15.7342 126.957 15.5808V16.5589C126.497 16.7507 125.576 16.8657 124.905 16.8657Z'
        fill='currentColor'
      />
      <path
        d='M114.555 16.9234C111.697 16.9234 109.684 14.8714 109.684 12.0714V11.8029C109.684 8.84946 111.716 6.7207 114.555 6.7207H114.574C117.259 6.7207 119.119 8.61933 119.119 11.381V12.2823H110.815V12.3207C110.949 14.3919 112.484 15.8494 114.632 15.8494C116.07 15.8494 117.336 15.1974 118.007 14.2385L118.87 14.8138C117.873 16.1755 116.281 16.9234 114.555 16.9234ZM110.853 11.2659H118.045V11.2084C117.968 9.17549 116.53 7.79467 114.497 7.79467C112.484 7.79467 111.045 9.19467 110.853 11.2659Z'
        fill='currentColor'
      />
      <path
        d='M102.77 16.9234C99.9121 16.9234 97.8984 14.8714 97.8984 12.0714V11.8029C97.8984 8.84946 99.9313 6.7207 102.77 6.7207H102.789C105.474 6.7207 107.334 8.61933 107.334 11.381V12.2823H99.0299V12.3207C99.1642 14.3919 100.698 15.8494 102.846 15.8494C104.285 15.8494 105.55 15.1974 106.222 14.2385L107.085 14.8138C106.087 16.1755 104.496 16.9234 102.77 16.9234ZM99.0683 11.2659H106.26V11.2084C106.183 9.17549 104.745 7.79467 102.712 7.79467C100.698 7.79467 99.2601 9.19467 99.0683 11.2659Z'
        fill='currentColor'
      />
      <path d='M93.8633 16.8082V3H94.9373V16.8082H93.8633Z' fill='currentColor' />
      <path
        d='M83.7495 16.8084V3.38379H91.0947V4.47694H84.9002V9.69336H90.7111V10.7865H84.9002V16.8084H83.7495Z'
        fill='currentColor'
      />
      <path
        d='M77.0187 16.9997C75.2544 16.9997 73.6818 16.5202 72.416 15.5613L73.5859 13.8545C74.5256 14.6024 75.9064 15.0627 77.1338 15.0627C78.2461 15.0627 78.8598 14.66 78.8598 13.9504C78.8598 13.0107 77.7092 12.9339 75.7722 12.3586C74.3338 11.9942 72.9146 11.3805 72.9146 9.6545C72.9146 7.79424 74.4872 6.64355 76.6544 6.64355C78.1502 6.64355 79.6653 7.10383 80.7393 7.9093L79.6078 9.57779C78.8215 8.98327 77.6133 8.58053 76.5776 8.58053C75.5804 8.58053 75.0818 8.9641 75.0818 9.55861C75.0818 10.2107 75.8872 10.5175 77.479 10.8627C79.1859 11.2271 81.1037 11.8408 81.1037 13.912C81.1037 15.7915 79.416 16.9997 77.0187 16.9997Z'
        fill='currentColor'
      />
      <path
        d='M64.6088 17.0003C62.3266 17.0003 61.0801 15.6386 61.0801 13.2222V6.83594H63.4582V12.7236C63.4582 14.1428 64.0718 14.9291 65.3951 14.9291H65.4335C67.0061 14.9291 68.0417 13.8743 68.0417 12.1866V6.83594H70.4198V16.8085H68.5403C68.4061 16.4249 68.2718 15.7537 68.2527 15.3126C67.3896 16.3482 66.1239 17.0003 64.6472 17.0003H64.6088Z'
        fill='currentColor'
      />
      <path
        d='M49.4199 16.8085L52.9679 11.7072V11.6304L49.5542 6.83594H52.2774L54.4446 10.2304H54.5405L56.7076 6.83594H59.3541L55.9788 11.6304V11.7072L59.4884 16.8085H56.7843L54.4446 13.1455H54.3679L52.0857 16.8085H49.4199Z'
        fill='currentColor'
      />
      <path
        d='M43.7632 16.9809C40.7331 16.9809 38.6235 14.948 38.6235 12.0138V11.7453C38.6235 8.81102 40.7907 6.66309 43.7249 6.66309H43.84C46.6016 6.66309 48.5961 8.58089 48.5961 11.2658V12.5507H40.9824V12.5699C41.155 14.0083 42.3057 14.9863 43.9167 14.9863H44.0126C45.24 14.9863 46.3523 14.4302 46.9276 13.7014L48.2509 15.1398C47.3112 16.2713 45.5852 16.9809 43.9358 16.9809H43.7632ZM41.04 10.959H46.3331C46.218 9.53979 45.2016 8.52335 43.7441 8.52335H43.7249C42.3441 8.52335 41.3085 9.48226 41.04 10.959Z'
        fill='currentColor'
      />
      <path
        d='M25.0957 16.8084V3.38379H27.9149L33.4765 12.9153H33.6299V3.38379H36.0655V16.8084H33.4957L27.7039 6.81665H27.5505V16.8084H25.0957Z'
        fill='currentColor'
      />
      <defs>
        <linearGradient
          id='paint0_linear_20124_52262'
          x1='13.6729'
          y1='0.046875'
          x2='13.6729'
          y2='20.0005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4EC0FF' />
          <stop offset='1' stopColor='#78BEFF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_20124_52262'
          x1='2.94678'
          y1='2.26367'
          x2='2.94678'
          y2='20.386'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#071EDB' />
          <stop offset='1' stopColor='#0823A5' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_20124_52262'
          x1='6.64266'
          y1='0'
          x2='6.64266'
          y2='18.8411'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#286AFC' />
          <stop offset='1' stopColor='#2866FC' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_20124_52262'
          x1='2.59194'
          y1='5.41672'
          x2='9.66446'
          y2='5.52958'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FC0FF' />
          <stop offset='1' stopColor='#2867FD' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_20124_52262'
          x1='5.42227'
          y1='10.7106'
          x2='12.3769'
          y2='10.5977'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FC0FF' />
          <stop offset='1' stopColor='#2867FD' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_20124_52262'
          x1='15.3234'
          y1='10.0936'
          x2='19.0957'
          y2='10.0936'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_20124_52262'
          x1='3.2048'
          y1='13.709'
          x2='5.90886'
          y2='13.709'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_20124_52262'
          x1='13.7323'
          y1='0.0109297'
          x2='8.681'
          y2='19.1016'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EAE348' />
          <stop offset='0.265625' stopColor='#E7EA48' />
          <stop offset='1' stopColor='#EAE348' stopOpacity='0.45' />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
});
